__turbopack_context__.v({
  "component": "search-bar-module-scss-module__VT8KBG__component",
  "dropdown": "search-bar-module-scss-module__VT8KBG__dropdown",
});
